<template>
  <div class="pc-index">
    <div class="pc-index-hearder">
      <h3>数据概况</h3>
      <!-- 选择日期 -->
      <div class="choiceDate">
        <el-radio-group
          v-model="tabPosition"
          @change="changeTime"
          style="margin-bottom: 30px"
        >
          <el-radio-button label="lastWeek">过去7天</el-radio-button>
          <el-radio-button label="lastMonth">过去30天</el-radio-button>
          <el-radio-button label="lastYear">本年度</el-radio-button>
        </el-radio-group>
        <div class="block">
          <el-date-picker
            v-model="timeChoice"
            type="daterange"
            style="width: 240px"
            :clearable="false"
            range-separator="至"
            unlink-panels
            :start-placeholder="
              $dtime(statisticArgs.start_time).format('YYYY-MM-DD ')
            "
            :end-placeholder="
              $dtime(
                new Date(statisticArgs.end_time).getTime() - 1000 * 60 * 60 * 24
              ).format('YYYY-MM-DD')
            "
            :default-time="['00:00:00', '00:00:00']"
            @change="pickerOptions"
          />
        </div>
      </div>
    </div>
    <ul class="pc-index-data">
      <li :class="item.class" v-for="(item, index) in indexData" :key="index">
        <div class="pc-index-data-icon">
          <div class="pc-index-data-icon-bg">
            <div class="iconfont">&#xe652;</div>
          </div>
        </div>
        <div class="pc-index-data-show">
          <span class="page-view-font">{{ item.num }}</span>
          <span>{{ item.type }}</span>
        </div>
      </li>
    </ul>
    <!-- 浏览趋势 -->
    <div class="pc-browseTrend">
      <BrowseTrend
        v-show='webData.code'
        :dates ='statisticArgs'
        :webDataBrowseTrend="webData"
      />
      <div
        v-show='!webData.code'
        class="hot-echarts-browseTrend-null"
      >
        <h2>暂时没有数据</h2>
      </div>
    </div>
    <!-- 展示热门的echarts -->
    <div class="hot-echarts">
      <div class="hot-echarts-HotProvinces">
        <h3>页面TOP10</h3>
        <HotPage
           v-show='webData.code'
          :webData="webData"
        />
        <div
          v-show='!webData.code'
          class="hot-echarts-HotProvinces-null"
        >
          <h2>暂时没有数据</h2>
        </div>
      </div>
      <div class="hot-echarts-HotCity">
        <h3>城市TOP10</h3>
        <HotCity :webData="webData" v-show='webData.code' />
        <div
           v-show='!webData.code'
          class="hot-echarts-HotCity-null"
        >
          <h2>暂时没有数据</h2>
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <!-- <div class="hot-echarts-form">
      <h3>板块访问数</h3>
      <div class="park-btn">
        <span class="f14 bold">设备：</span>
        <el-select
          v-model="equipmentSelect"
          @change="choiceEquipment"
          clearable
        >
          <el-option
            v-for="(item, index) in equipmentList"
            :key="index"
            :label="item.name"
            :value="index"
          ></el-option>
        </el-select>
      </div>

      <el-table
        :data="webDateBrowse"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
        default-expand-all
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column prop="datetime" label="时间" sortable width="180">
        </el-table-column>
        <el-table-column
          :prop="equipmentList[equipmentChoice].value + 'visitorNumber'"
          label="访客数"
          sortable
          width="180"
        >
        </el-table-column>
        <el-table-column
          :prop="equipmentList[equipmentChoice].value + 'ipNumber'"
          sortable
          label="IP数"
        >
        </el-table-column>
        <el-table-column
          :prop="equipmentList[equipmentChoice].value + 'eventNumber'"
          sortable
          label="事件量"
        >
        </el-table-column>
        <el-table-column
          :prop="equipmentList[equipmentChoice].value + 'viewNumber'"
          sortable
          label="浏览量"
        >
        </el-table-column>
        <el-table-column
          :prop="equipmentList[equipmentChoice].value + 'average'"
          sortable
          label="平均浏览"
        >
        </el-table-column>
        <el-table-column
          :prop="equipmentList[equipmentChoice].value + 'newVisitorNumber'"
          sortable
          label="新访客率"
        >
        </el-table-column>
        <el-table-column
          :prop="equipmentList[equipmentChoice].value + 'bounceRate'"
          sortable
          label="跳出率"
        >
        </el-table-column>
      </el-table>
    </div> -->
    <!-- 表单 -->
    <div class="hot-echarts-template">
      <h3>板块数据</h3>
      <!-- v-if="webDatePlate.length!= 0" -->
      <!-- <div v-if="webDate.section.length!= 0"> -->
      <!-- v-if="webDate.section.length != 0" -->
      <TemplateData
        :webData="webData"
        v-show='webData.code'
      />
      <!-- </div> -->
      <div
         v-show='!webData.code'
        class="hot-echarts-template-null"
      >
        <h2>暂时没有数据</h2>
      </div>
    </div>
  </div>
</template>
<script>
import BrowseTrend from "./BrowseTrend";
import HotPage from "./HotPage";
import HotCity from "./HotCity";
import TemplateData from "./TemplateData";
import { getHomeStatistics_Api } from "../../../apis/statistics.api";
// import { getDailyStatisticses } from "./main.gql";
import { from } from "apollo-link";
export default {
  components: { BrowseTrend, HotPage, HotCity, TemplateData },
  data() {
    return {
      indexData: [
        { class: "page-view", type: "浏览量", num: "0" },
        { class: "ip-data", type: "注册用户访问数", num: "0" },
        { class: "new-visitors-rate", type: "注册用户数", num: "0" },
      ],
      tabPosition: "lastWeek",
      statisticArgs: {
        start_time: "",
        end_time: "",
      },
      initDate: {
        today: null,
        oneWeekAgo: null,
        oneMonthAgo: null,
        firstDayThisYear: null,
      },
      // 所有数据
      webData: {},

      // 存储当前日期网络数据
      webDate: [],
      // 存储热门省份
      webDateArea: [],
      // 存储热门城市
      webDateCity: [],

      // 存储浏览趋势时间轴
      webDateBrowseTrend: [],
      // 存储浏览分析
      webDateBrowse: [],
      // 模板数据:
      webDatePlate: [],

      equipmentSelect: "全部",
      webSiteSelect: "WUPEN",
      equipmentList: [
        { name: "全部", value: "total." },
        { name: "安卓", value: "Android." },
        { name: "苹果", value: "iPhone." },
        { name: "电脑", value: "PC." },
      ],
      // 浏览分析选中的是哪个设备
      equipmentChoice: "0",
      // 浏览分析
      analysisList: [],
      // 时间选择器
      timeChoice: [],
      // 后端需要的参数

      // el table的数据
      tableData: [],
    };
  },
  created() {
    this.initialDate();
  },
  mounted() {
    this.getDailyStatisticses();
  },
  methods: {
    initialDate() {
      let oneDay = 1000 * 60 * 60 * 24;
      let _morn = new Date().getTime();

      this.initDate.today = this.$dtime(new Date(_morn + oneDay)).format(
        "YYYY-MM-DD"
      );

      let _diffVal = 1000 * 60 * 60 * 24 * 7;
      this.initDate.oneWeekAgo = this.$dtime(
        new Date(oneDay + _morn - _diffVal)
      ).format("YYYY-MM-DD");

      _diffVal = 1000 * 60 * 60 * 24 * 30;
      this.initDate.oneMonthAgo = this.$dtime(
        new Date(oneDay + _morn - _diffVal)
      ).format("YYYY-MM-DD");

      this.initDate.firstDayThisYear = this.$dtime(
        new Date(new Date().setMonth("0")).setDate("1")
      ).format("YYYY-MM-DD");
      console.log(this.initDate);

      this.statisticArgs.start_time = this.initDate.oneWeekAgo;
      this.statisticArgs.end_time = this.initDate.today;
      console.log(this.statisticArgs);
    },
    pickerOptions(value) {
      console.log(this.timeChoice);
      let oneDay = 1000 * 60 * 60 * 24;
      this.statisticArgs.start_time = this.$dtime(new Date(value[0])).format(
        "YYYY-MM-DD"
      );
      this.statisticArgs.end_time = this.$dtime(
        new Date(value[1]).getTime() + oneDay
      ).format("YYYY-MM-DD");
      this.tabPosition = "";
      this.getDailyStatisticses();
    },
    changeTime(tab, event) {
      this.timeChoice = [];
      this.statisticArgs.end_time = this.initDate.today;
      this.timeChoice[1] = this.$dtime(
        new Date(this.initDate.today).getTime() - 1000 * 60 * 60 * 24
      ).format("YYYY-MM-DD hh:mm:ss");
      console.log(tab);
      if (tab == "lastWeek") {
        this.timeChoice[0] = this.$dtime(this.initDate.oneWeekAgo).format(
          "YYYY-MM-DD hh:mm:ss"
        );
        this.statisticArgs.start_time = this.initDate.oneWeekAgo;
      }
      if (tab == "lastMonth") {
        this.timeChoice[0] = this.$dtime(this.initDate.oneMonthAgo).format(
          "YYYY-MM-DD hh:mm:ss"
        );
        this.statisticArgs.start_time = this.initDate.oneMonthAgo;
      }
      if (tab == "lastYear") {
        this.timeChoice[0] = this.$dtime(this.initDate.firstDayThisYear).format(
          "YYYY-MM-DD hh:mm:ss"
        );
        this.statisticArgs.start_time = this.initDate.firstDayThisYear;
      }
      console.log(this.timeChoice);
      this.getDailyStatisticses();
    },
    // 加载页面
    getDailyStatisticses() {
      getHomeStatistics_Api(this.statisticArgs).then((res) => {
        console.log(res);
        this.indexData[0].num = res.total_pv;
        this.indexData[1].num = res.register_user_view_count;
        this.indexData[2].num = res.register_user_count;
        this.webData = res;
      });
    },
    // 模板数据
    datePlate(plate) {
      this.webDatePlate = plate;
    },
    // 浏览分析
    browse(period) {
      // this.webDate
      this.webDateBrowse = period;
      for (let i = 0; this.webDateBrowse.length > i; i++) {
        // 判断当前显示的是否为昨天的数据
        if (this.tabPosition == "yesterdayLater") {
          this.webDateBrowse[i].datetime =
            this.webDateBrowse[i].datetime + ":00";
        }
        // 计算出平均数
        this.webDateBrowse[i].total.average = Math.round(
          this.webDateBrowse[i].total.viewNumber /
            this.webDateBrowse[i].total.visitorNumber
        );
        this.webDateBrowse[i].Android.average = Math.round(
          this.webDateBrowse[i].Android.viewNumber /
            this.webDateBrowse[i].Android.visitorNumber
        );
        this.webDateBrowse[i].iPhone.average = Math.round(
          this.webDateBrowse[i].iPhone.viewNumber /
            this.webDateBrowse[i].iPhone.visitorNumber
        );
        this.webDateBrowse[i].PC.average = Math.round(
          this.webDateBrowse[i].PC.viewNumber /
            this.webDateBrowse[i].PC.visitorNumber
        );
        //  计算跳出页
        this.webDateBrowse[i].total.bounceRate =
          Math.floor(
            (this.webDateBrowse[i].total.jumpNumber /
              this.webDateBrowse[i].total.viewNumber) *
              1000
          ) / 1000;
        this.webDateBrowse[i].Android.bounceRate =
          Math.floor(
            (this.webDateBrowse[i].Android.jumpNumber /
              this.webDateBrowse[i].Android.viewNumber) *
              1000
          ) / 1000;
        this.webDateBrowse[i].iPhone.bounceRate =
          Math.floor(
            (this.webDateBrowse[i].iPhone.jumpNumber /
              this.webDateBrowse[i].iPhone.viewNumber) *
              1000
          ) / 1000;
        this.webDateBrowse[i].PC.bounceRate =
          Math.floor(
            (this.webDateBrowse[i].PC.jumpNumber /
              this.webDateBrowse[i].PC.viewNumber) *
              1000
          ) / 1000;
        // 检测非空
        this.webDateBrowse[i].total.average = this.findNotNull(
          this.webDateBrowse[i].total.average
        );
        this.webDateBrowse[i].Android.average = this.findNotNull(
          this.webDateBrowse[i].Android.average
        );
        this.webDateBrowse[i].iPhone.average = this.findNotNull(
          this.webDateBrowse[i].iPhone.average
        );
        this.webDateBrowse[i].PC.average = this.findNotNull(
          this.webDateBrowse[i].PC.average
        );
        this.webDateBrowse[i].total.bounceRate = this.changePercentage(
          this.webDateBrowse[i].total.bounceRate
        );
        this.webDateBrowse[i].Android.bounceRate = this.changePercentage(
          this.webDateBrowse[i].Android.bounceRate
        );
        this.webDateBrowse[i].iPhone.bounceRate = this.changePercentage(
          this.webDateBrowse[i].iPhone.bounceRate
        );
        this.webDateBrowse[i].PC.bounceRate = this.changePercentage(
          this.webDateBrowse[i].PC.bounceRate
        );
        //  conosole.log(isNaN( this.webDateBrowse[i].total.bounceRate))
      }
    },
    // 浏览分析选择设备
    choiceEquipment(event) {
      this.equipmentChoice = event;
    },

    // 浏览趋势
    browseTrend(period) {
      // 计算出浏览趋势应该展示的日期
      // let a=this.getTwoTimeList(this.statisticArgs.end_time,this.statisticArgs.start_time)
      // 给浏览趋势赋上数据
      this.webDataBrowseTrend = period;

      // 给浏览趋势赋上时间轴
      if (this.tabPosition == "yesterdayLater") {
        this.webDateBrowseTrend = [
          "0:00",
          "1:00",
          "2:00",
          "3:00",
          "4:00",
          "5:00",
          "6:00",
          "7:00",
          "8:00",
          "9:00",
          "10:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
        ];
      } else {
        let a = this.$dtime(this.statisticArgs.end_time).format("YYYY-MM-DD ");
        let b = this.$dtime(this.statisticArgs.start_time).format(
          "YYYY-MM-DD "
        );
        this.getdiffdate(b, a);
      }
    },
    getdiffdate(stime, etime) {
      this.webDateBrowseTrend = [];
      // stime=stime - 24 * 60 * 60 * 1000
      //初始化日期列表，数组
      var diffdate = new Array();
      var i = 0;
      // 将拿到的第一天设置为正确日期
      var stimeGetTime = new Date(stime).getTime();
      var stimeDate = stimeGetTime - 24 * 60 * 60 * 1000;
      stime = new Date(stimeDate);
      stime = this.$dtime(stime).format("YYYY-MM-DD ");
      // 将拿到的下一天设置为正确日期
      var etimeGetTime = new Date(etime).getTime();
      var etimeDate = etimeGetTime - 24 * 60 * 60 * 1000;
      etime = new Date(etimeDate);
      etime = this.$dtime(etime).format("YYYY-MM-DD ");
      // console.log(stime);
      //开始日期小于等于结束日期,并循环
      while (stime < etime) {
        diffdate[i] = stime;
        //获取开始日期时间戳
        var stime_ts = new Date(stime).getTime();
        // console.log("当前日期：" + stime + "当前时间戳：" + stime_ts,'zhongjie',etime);
        //增加一天时间戳后的日期
        var next_date = stime_ts + 24 * 60 * 60 * 1000;
        //拼接年月日，这里的月份会返回（0-11），所以要+1
        var next_dates_y = new Date(next_date).getFullYear() + "-";
        var next_dates_m =
          new Date(next_date).getMonth() + 1 < 10
            ? "0" + (new Date(next_date).getMonth() + 1) + "-"
            : new Date(next_date).getMonth() + 1 + "-";
        var next_dates_d =
          new Date(next_date).getDate() < 10
            ? "0" + new Date(next_date).getDate()
            : new Date(next_date).getDate();

        stime = next_dates_y + next_dates_m + next_dates_d;
        // //增加数组key
        i++;
        // 做一个赋值
        this.webDateBrowseTrend.push(stime);
      }
    },
    // 转成百分比
    findNotNull(point) {
      if (isNaN(point)) {
        point = 0;
        return 0;
      }
      return point;
    },
    changePercentage(point) {
      if (isNaN(point)) {
        point = 0;
        return 0;
      }
      var str = Number(point * 100).toFixed();
      str += "%";
      return str;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .app-wrapper .header {
  top: 0 !important;
}
.pc-index {
  margin-top: 25px;
  // 显示网站数据CSS
  .pc-index-hearder {
    margin-bottom: 40px;
    font-size: 20px;
    padding: 0 0 24px;
    display: flex;
    border-bottom: 1px solid $indexHotLine;
    justify-content: space-between;
    h3 {
      // text-align: start;
      align-self: center;
      font-size: 20px;
      // padding: 25px 0;
    }
    .park-btn {
      align-self: center;
      .f14 {
        font-size: 18px;
        font-weight: 400;
        color: $mainTitle;
      }
    }

    .choiceDate {
      align-self: center;
      display: flex;
      .el-radio-group {
        display: flex;
        margin-right: 40px;
        margin-bottom: 0 !important;
        li {
          width: 100px;
          padding: 6px 0px;
          border: 1px solid $thirdTitle;
          font-size: 14px;
          cursor: pointer;
          // background: $timeBtn;
          // color: $base-color;
        }
      }
      .block {
        .el-range-editor.el-input__inner {
          width: 240px;
        }
        /deep/ .el-date-editor .el-range-separator {
          width: 9%;
          padding: 0;
        }
      }
    }
  }
  .pc-index-data {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    li {
      width: 390px;
      height: 120px;
      background: #ffffff;
      box-shadow: $boxshadow;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      padding: 0 30px 0 25px;
      margin: 0 15px;
      .pc-index-data-icon {
        align-self: center;
        width: 80px;
        height: 80px;
        display: flex;
        justify-content: center;
        border-radius: 45px;
        .pc-index-data-icon-bg {
          width: 60px;
          height: 60px;
          align-self: center;
          display: flex;
          justify-content: center;
          border-radius: 45px;
          .iconfont {
            align-self: center;
            font-size: 36px;
            color: $base-color;
          }
        }
      }
      .pc-index-data-show {
        align-self: center;
        display: flex;
        flex-direction: column;
        span:nth-of-type(1) {
          font-size: 36px;
          font-weight: 600;
          font-family: $chinese;
        }
        span:nth-of-type(2) {
          color: $thirdTitle;
          font-size: 14px;
          font-family: $chinese;
          font-weight: 400;
          align-self: flex-end;
        }
        .page-view-font {
          font-size: 40px !important;
        }
      }
    }
    li:nth-of-type(1) {
      margin-left: 0;
    }
    li:nth-of-type(4) {
      margin-right: 0;
    }
    //   浏览量的颜色
    .page-view {
      .pc-index-data-icon {
        background: $pageViewBig;
        .pc-index-data-icon-bg {
          background: $pageViewSmall;
        }
      }
      .pc-index-data-show {
        span:nth-of-type(1) {
          color: $pageViewSmall;
        }
      }
    }
    //   访问量的颜色
    .visitor-volume {
      .pc-index-data-icon {
        background: $visitorVolumeBig;
        .pc-index-data-icon-bg {
          background: $visitorVolumeSmall;
        }
      }
      .pc-index-data-show {
        span:nth-of-type(1) {
          color: $visitorVolumeSmall;
        }
      }
    }
    //   IP量的颜色
    .ip-data {
      .pc-index-data-icon {
        background: $ipDataBig;
        .pc-index-data-icon-bg {
          background: $ipDataSmall;
        }
      }
      .pc-index-data-show {
        span:nth-of-type(1) {
          color: $ipDataSmall;
        }
      }
    }
    //   访问量的颜色
    .new-visitors-rate {
      .pc-index-data-icon {
        background: $newVisitorsRateBig;
        .pc-index-data-icon-bg {
          background: $newVisitorsRateSmall;
        }
      }
      .pc-index-data-show {
        span:nth-of-type(1) {
          color: $newVisitorsRateSmall;
        }
      }
    }
  }
  // 显示浏览趋势
  .pc-browseTrend {
    display: flex;
    justify-content: space-between;
    margin: 30px 0 40px;
    height: 500px;
    > div {
      width: 100%;

      box-shadow: $boxshadow;
      padding: 40px;
    }
    .hot-echarts-browseTrend-null {
      height: 100%;
      display: flex;
      justify-content: center;
      h2 {
        align-self: center;
      }
    }
  }
  // 显示热门数据echarts
  .hot-echarts {
    display: flex;
    justify-content: space-between;
    margin: 30px 0;
    > div {
      width: 49%;
      height: 500px;
      box-shadow: $boxshadow;
      padding: 30px;
      h3 {
        // padding
        text-align: start;
        border-bottom: 1px solid $indexHotLine;
        padding: 15px 0;
      }
      .hot-echarts {
      }
    }
    .hot-echarts-HotProvinces {
      .hot-echarts-HotProvinces-null {
        height: 100%;
        display: flex;
        justify-content: center;
        h2 {
          align-self: center;
        }
      }
    }
    .hot-echarts-HotCity {
      .hot-echarts-HotCity-null {
        height: 100%;
        display: flex;
        justify-content: center;
        h2 {
          align-self: center;
        }
      }
    }
    // justify-content: space-between;
  }
  .hot-echarts-form {
    //  width: %;
    // height: 500px;
    box-shadow: $boxshadow;
    // margin: 30px;
    padding: 30px;
    h3 {
      text-align: start;
      border-bottom: 1px solid $indexHotLine;
      padding: 15px 0;
    }
    .park-btn {
      margin-top: 20px;
      margin-bottom: 30px;
      text-align: start;
    }
  }
  .hot-echarts-template {
    height: 900px;
    box-shadow: $boxshadow;
    margin-top: 40px;
    padding: 30px;
    h3 {
      text-align: start;
      border-bottom: 1px solid $indexHotLine;
      padding: 15px 0;
      margin-bottom: 35px;
    }
    .hot-echarts-template-null {
      height: 100%;
      display: flex;
      justify-content: center;
      h2 {
        align-self: center;
      }
    }
  }
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: $timeBtn;
  border-color: $timeBtn;
  box-shadow: -1px 0 0 0 $timeBtn;
}
// 日期选择器样式
/deep/ .el-date-editor .el-range__icon {
  font-size: 20px;
  position: absolute;
  right: 8px;
  top: 2px;
}
// 数据概括显示昨天过去7天过去30天
/deep/ .el-radio-button__inner {
  max-width: 100px;
  // height: 30px;
  // padding: auto;
  font-size: 14px;
  color: $timeWorld;
  // padding-bottom: 8px;
  // padding-top: 8px;
}
// /deep/ .el-radio-button__inner:hover{
//   color: $secondTitle;
// }
</style>




// WEBPACK FOOTER //
// src/components/admin/index/Main.vue